import {
    FaCloud,
    FaArrowsRotate,
    FaSliders,
    FaFileInvoiceDollar,
    FaUsers,
    FaRobot,
    FaHeadset,
    FaWallet,
    FaChartLine,
    FaLaptopMedical,
} from "react-icons/fa6";

export const benefitsData = [
    {
        title: "Cloud-Based & Secure",
        description:
            "Access patient records anytime and anywhere with our HIPAA-compliant cloud platform.",
        icon: FaCloud,
    },
    {
        title: "Streamlined Workflows",
        description:
            "Enhance your efficiency by automating documentation, e-prescriptions, and patient charting.",
        icon: FaArrowsRotate,
    },
    {
        title: "Customizable for Any Practice",
        description:
            "Get solutions designed for primary care, specialists, and large healthcare facilities.",
        icon: FaSliders,
    },
    {
        title: "Integrated Billing & Claims Processing",
        description:
            "Cut down claim denials with our smart medical billing and coding features.",
        icon: FaFileInvoiceDollar,
    },
    {
        title: "Enhanced Patient Engagement",
        description:
            "Patient portals provide health records, appointment scheduling, and communication tools.",
        icon: FaUsers,
    },
    {
        title: "AI Scribing Feature",
        description:
            "Capture real-time patient interactions, converting them into accurate notes to reduce documentation time and enhance patient care.",
        icon: FaRobot,
    },
    {
        title: "24/7 Support",
        description:
            "Our team is available around the clock to assist with any questions or issues you may face.",
        icon: FaHeadset,
    },
    {
        title: "No Upfront Costs",
        description:
            "Begin with our flexible monthly subscription—no big setup fees required!",
        icon: FaWallet,
    },
];

export const collectionSteps = [
    {
        id: 1,
        number: "01",
        icon: <FaCloud />,
        title: "Cloud-Based EMR Access",
        description:
            "Secure patient records from any device with cloud-based EMR access.",
    },
    {
        id: 2,
        number: "02",
        icon: <FaFileInvoiceDollar />,
        title: "EMR Billing & Claims",
        description:
            "Simplify billing, claims, and revenue cycle management for faster payments.",
    },
    {
        id: 3,
        number: "03",
        icon: <FaArrowsRotate />,
        title: "Automated EMR Workflows",
        description:
            "Automate intake, prescriptions, and documentation to improve clinical efficiency.",
    },
    {
        id: 4,
        number: "04",
        icon: <FaSliders />,
        title: "Customizable EMR Solutions",
        description:
            "Customize EMR workflows for primary care, specialists, and healthcare facilities.",
    },
    {
        id: 5,
        number: "05",
        icon: <FaChartLine />,
        title: "EMR Analytics & Reporting",
        description:
            "Monitor practice performance with actionable healthcare analytics and reports.",
    },
    {
        id: 6,
        number: "06",
        icon: <FaLaptopMedical />,
        title: "Telehealth & Patient Portal",
        description:
            "Connect patients with telehealth, scheduling, records, and secure messaging.",
    },
];